// Feature: M004-F0701 (WebUI #106 inline installation picker). Tests: T-M004-0179, T-M004-0181.
// Design authority: docs/design/M004-F0672-Ledger-Nav-Canonical-Page.md §2.
//
// Pure helpers for the picker. Core knows WHO and WHICH installations the
// caller may open; this module only normalises what Core sent and words it.
// It invents no installation and computes nothing about access.

export const INSTALLATION_REQUIRED = 'LEDGER_INSTALLATION_REQUIRED';
export const INSTALLATION_NOT_FOUND = 'LEDGER_INSTALLATION_NOT_FOUND';

// Core's AppError envelope is flat ({ success:false, error:'CODE', message });
// tolerate the nested { error:{ code, message } } spelling other routes use.
export const coreErrorCode = (cause) => {
  const data = cause?.response?.data;
  if (typeof data?.error === 'string') return data.error;
  return data?.error?.code || data?.code || '';
};

export const coreErrorMessage = (cause, fallback) => (
  cause?.response?.data?.message
  || cause?.response?.data?.error?.message
  || cause?.message
  || fallback
);

// `GET /ledger/node-workspace/installations` -> { success, data: { ownerOrgId, installations } }.
export const normaliseInstallations = (response) => {
  const body = response?.data?.data || response?.data || {};
  const rows = Array.isArray(body.installations) ? body.installations : [];
  return rows
    .filter((row) => typeof row?.installationUuid === 'string' && row.installationUuid)
    .map((row) => ({
      installationUuid: row.installationUuid,
      installLabel: typeof row.installLabel === 'string' && row.installLabel.trim() ? row.installLabel.trim() : null,
      lastSeenAt: row.lastSeenAt || null,
      online: row.online === true,
    }));
};

export const installationName = (installation) => (
  installation.installLabel || `Unnamed Ledger server (${installation.installationUuid.slice(0, 8)})`
);

export const lastSeenText = (installation) => {
  if (!installation.lastSeenAt) return 'Never seen';
  const when = new Date(installation.lastSeenAt);
  if (Number.isNaN(when.getTime())) return 'Last seen: unknown';
  return `Last seen ${when.toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' })}`;
};

export const OFFLINE_REASON = 'Offline: it cannot be opened until it reconnects.';
